import { BCMSRecord, DisabledPrompt, Link, useBCMSContext, useParams } from "@bcm-dev/bcms-vite";
import { FormContainer, FormRowView } from "components/shared";
import { FormButtonRow } from "components/shared/containers/FormContainer";
import { UIButton } from "components/ui";
import Classes, { UserAccount } from "model";
import { SVGAsset } from "res";

export default function ManageRecipientContent(props) {
    const context = useBCMSContext();
    let { id } = useParams();
    const data = { ...getDefaultPageData(), ...props.data ?? {} };
    const ui = { ...getDefaultPageUI(), ...props.ui ?? {} };
    id = data.id ? data.id : id;
    BCMSRecord.globalControllerFor(Classes, context);
    const account = UserAccount.initByID(id);

    return (
        <div className="manage-recipient-content back-link-padding">
            <Link to="/advancedAlerts/manageRecipients" className="back-link">
                <span>
                    <SVGAsset id="LeftChevronIcon" data-point="Manage_Recipients_Back_Button_Chevron" />
                    <span data-point="Manage_Recipients_Back_Button_Label">Back</span>
                </span>
            </Link>

            <p className="page-subtitle">Manage Recipient</p>

            <FormContainer className="small-form-width">
                <FormRowView>
                    <p className="recipient-container">
                        <span data-point="Manage_Recipient_Recipient_Label">{ `Recipient` }</span>   
                        <span data-point="Manage_Recipient_Recipient_Value"> { account.emailAddress }</span>
                    </p>
                </FormRowView>

                <FormButtonRow>
                    <DisabledPrompt>
                        <UIButton className="primary-button disabled" dataPoint="Manage_Recipient_Activate_Button" text="Activate" />
                        <UIButton className="primary-button" dataPoint="Manage_Recipient_Delete_Button" text="Delete" />
                    </DisabledPrompt>
                </FormButtonRow>
            </FormContainer>
        </div>
    );
}

export const getDefaultPageData = () => ({
 
});

export const getDefaultPageUI = () => ({
  
});